import {
  Box,
  Stack,
  type StackProps,
} from '@ace-clublabs/shared-component-library';
import { useEffect, useRef } from 'react';

interface BlockScreenProps extends StackProps {
  blocked: boolean;
  children: React.ReactNode;
  sx?: StackProps['sx'];
}

const BlockScreen: React.FC<BlockScreenProps> = ({
  blocked,
  children,
  sx = [],
  ...rest
}) => {
  const stackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (blocked) {
      stackRef.current?.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      });
    }
  }, [blocked]);

  return (
    <Stack
      ref={stackRef}
      sx={[
        {
          position: 'relative',
        },
        blocked && {
          overflow: 'hidden !important',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {children}
      {blocked && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            bgcolor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
          }}
        />
      )}
    </Stack>
  );
};

export default BlockScreen;
